module.exports = __webpack_public_path__ + "static/18-aerial-views-iii-e9718814659a94c3d5fddbc417a2c552.jpeg";